<template>
  <div class="modal-window bds067">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.TableModal.001","표 추가") }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <ul class="list-table">
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("title.TableModal.002","행/열 개수") }}</dt>
            <dd>
              {{ $i18nUtil.trans("title.TableModal.003","행 개수") }}
              <form>
                <div class="input-box">
                  <input type="text" required v-model="rows" 
                  ref="inpRows"
                  @input="validate"
                  @keydown="validate"
                  @keyup="validate"
                  placeholder="">
                  <button type="reset" class="input-txt-del">입력 삭제</button>
                </div>
              </form>
              {{ $i18nUtil.trans("title.TableModal.004","열 개수") }}
              <form>
                <div class="input-box">
                  <input type="text" required v-model="cols"
                  ref="inpCols"
                  @input="validate"
                  @keydown="validate"
                  @keyup="validate"
                  placeholder="">
                  <button type="reset" class="input-txt-del">입력 삭제</button>
                </div>
              </form>
              <div ref="msg" class="error ty1 hidden">{{ $i18nUtil.trans("message.TableModal.001","숫자만 입력 가능합니다.") }}</div>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("title.TableModal.005","표 형식") }}</dt>
            <dd>
              <input type="radio" name="ra" id="ra1" v-model="type" value="0"><label for="ra1">{{ $i18nUtil.trans("message.TableModal.007","제목줄 없음") }}</label>
              <input type="radio" name="ra" id="ra2" v-model="type" value="1"><label for="ra2">{{ $i18nUtil.trans("message.TableModal.008","위쪽 제목줄") }}</label>
              <input type="radio" name="ra" id="ra3" v-model="type" value="2"><label for="ra3">{{ $i18nUtil.trans("message.TableModal.009","왼쪽 제목칸") }}</label>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("title.TableModal.006","제목줄 색상") }}</dt>
            <dd>
              <div class="color clear">
                <button type="button"
                  v-for="(color, inx) in modalInfo.tbColors" 
                  :value="color" :key="inx"
                  :class="'color-select hw-color-bg-' + inx"
                  @click="changeColor(inx)"
                >
                </button>
              </div>
            </dd>
          </dl>
        </li>
      </ul>
      <div class="box">
        <div>{{ $i18nUtil.trans("message.TableModal.010","예시") }}</div>
        <div class="tableWrapper" ref="tableSample">
        </div>
      </div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="onClickSubmit">{{ $i18nUtil.trans("button.save","저장") }}</button>
    </footer>
  </div>
</template>

<script>

export default {
  components: { 
  },
  props: {
    name: {
      type: String,
      required: false,
    },
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
        rows: 3,
        cols: 3,
        color: '2',
        type: 1
    };
  },
  mounted() {
    this.makeSample();
  },
  watch: {
    type() { this.makeSample(); },
    color() { this.makeSample(); }
  },
  methods: {
    changeColor(color) {
      this.color = color;
    },
    makeSample() {
      let wrapElement = this.makeTable(this.type, 2, 3, this.color, 540, true);
      this.$refs.tableSample.innerHTML="";
      this.$refs.tableSample.appendChild(wrapElement);
    },
    makeTable(type, rows, cols, color, tbWidth, isSample) {
      let wrapElement = document.createElement("div");
      let tableElement = document.createElement("table");
      let tbodyElement = document.createElement("tbody");
      let trElement = null;
      let tdElement = null;
      let pElement = null;
      let thinx = 0;
      let tdinx = 0;
      let colWidth = 0;
      if (tbWidth) {
        colWidth = Math.round(tbWidth / cols);
      }
      if (type == 0) {
        for (let rinx = 0; rinx < rows; rinx++) {
          trElement = document.createElement("tr");
          tbodyElement.appendChild(trElement);
          for (let cinx = 0; cinx < cols; cinx++) {
            tdElement = document.createElement("td");
            pElement = document.createElement("p");
            if (isSample) {
              pElement.innerHTML = this.$i18nUtil.trans("message.TableModal.002","내용이 들어갑니다.");
            } else {
              pElement.innerHTML = "";
            }
            tdElement.appendChild(pElement);
            if (colWidth) {
              tdElement.setAttribute("data-colwidth", colWidth);
            }
            trElement.appendChild(tdElement);
          }
        }
      }
      else if (type == 1) {
        for (let rinx = 0; rinx < rows; rinx++) {
          trElement = document.createElement("tr");
          tbodyElement.appendChild(trElement);
          for (let cinx = 0; cinx < cols; cinx++) {
            pElement = document.createElement("p");
            if (rinx == 0) {
              tdElement = document.createElement("th");
              if (isSample) {
                tdElement.setAttribute("style", "background:" + this.modalInfo.tbColors[this.color] + "");
                pElement.innerHTML = this.$i18nUtil.trans("message.TableModal.011","구분자") + (++thinx);
                pElement.style.textAlign = "center";
              } else {
                pElement.innerHTML = "";
              }
            } else {
              tdElement = document.createElement("td");
              if (isSample) {
                pElement.innerHTML = this.$i18nUtil.trans("message.TableModal.002","내용이 들어갑니다.");
              } else {
                pElement.innerHTML = "";
              }
            }
            tdElement.appendChild(pElement);
            if (colWidth) {
              tdElement.setAttribute("data-colwidth", colWidth);
            }
            trElement.appendChild(tdElement);
          }
        }
      }
      else if (type == 2) {
        for (let rinx = 0; rinx < rows; rinx++) {
          trElement = document.createElement("tr");
          tbodyElement.appendChild(trElement);
          for (let cinx = 0; cinx < cols; cinx++) {
            pElement = document.createElement("p");
            if (cinx == 0) {
              tdElement = document.createElement("th");
              if (isSample) {
                tdElement.setAttribute("style", "background:" + this.modalInfo.tbColors[this.color] + "");
                pElement.innerHTML = this.$i18nUtil.trans("message.TableModal.011","구분자") + (++thinx);
                pElement.style.textAlign = "center";
              } else {
                pElement.innerHTML = "";
              }
            } else {
              tdElement = document.createElement("td");
              if (isSample) {
                pElement.innerHTML = this.$i18nUtil.trans("message.TableModal.002","내용이 들어갑니다.");
              } else {
                pElement.innerHTML = "";
              }
            }
            tdElement.appendChild(pElement);
            if (colWidth) {
              tdElement.setAttribute("data-colwidth", colWidth);
            }
            trElement.appendChild(tdElement);
          }
        }
      }
      tableElement.appendChild(tbodyElement);
      wrapElement.appendChild(tableElement);
      wrapElement.classList.add("hw-tb-color-" + color);
      return wrapElement;
    },
    validate(e) {
      let err = false;
      let target = e ? e.target : null;
      let inpRows = this.$refs.inpRows;
      let inpCols = this.$refs.inpCols;
      let msgElement = null;

      let fnCheckNum = (val, min, max) => {
        let err = 0;
        val = val.replace(/^[ ]+/, "");
        val = val.replace(/[ ]+$/, "");
        if (val && !/^[0-9]+$/.exec(val)) {
          return this.$i18nUtil.trans("message.TableModal.003","숫자만 입력해 주세요");
        }
        else if (val === "") {
          return this.$i18nUtil.trans("message.TableModal.004","입력값을 채워주세요");
        }
        else if (val * 1 <= min) {
          return this.$i18nUtil.trans("message.TableModal.005","{num}보다 큰 숫자를 입력해 주세요", {num: min});
        }
        else if (val * 1 > max) {
          return this.$i18nUtil.trans("message.TableModal.006","{num}이하의 숫자를 입력해 주세요", {num: max});
        }
        return "";
      };

      if (target === inpRows) {
        // msgElement = this.$refs.msgRows;
        msgElement = this.$refs.msg;
        msgElement.classList.add("hidden");
        if (!err && inpRows.value && (err = fnCheckNum(inpRows.value, 0, 50))) {
          msgElement.classList.remove("hidden");
          msgElement.innerHTML = err;
        }
      }
      else if (target === inpCols) {
        // msgElement = this.$refs.msgCols;
        msgElement = this.$refs.msg;
        msgElement.classList.add("hidden");
        if (!err && inpCols.value && (err = fnCheckNum(inpCols.value, 0, 20))) {
          msgElement.classList.remove("hidden");
          msgElement.innerHTML = err;
        }
      }
      else if (!target) {
        // this.$refs.msgRows.classList.add("hidden");
        // this.$refs.msgCols.classList.add("hidden");
        msgElement = this.$refs.msg;
        msgElement.classList.add("hidden");
        if (!err && (err = fnCheckNum(inpRows.value, 0, 100))) {
          // msgElement = this.$refs.msgRows;
          msgElement.classList.remove("hidden");
          msgElement.innerHTML = err;
        }
        if (!err && (err = fnCheckNum(inpCols.value, 0, 50))) {
          // msgElement = this.$refs.msgCols;
          msgElement.classList.remove("hidden");
          msgElement.innerHTML = err;
        }
      }
      if (!err) {
        return true;
      }
      return false;
    },
    onClickSubmit() {
      if (this.validate()) {
        let width = this.modalInfo.tbWidth - 2;
        let element = this.makeTable(this.type, this.rows, this.cols, this.color, width, false);
        this.modalInfo.fnSubmit({ blockType: this.modalInfo.blockType, contentPath: element.outerHTML, sortNo: this.modalInfo.sortNo });
        this.$emit("close");
      }
    }
  },
};
</script>

<style scoped>
.input-box .input-txt-del {
  right: 34px;
}

.message {
  position: absolute;
  width: 200px;
}

.message .error {
  font-size: 12px;
  background: #fff;
  padding: 10px;
  border: 1px solid #eee;
  left: -20px;
  top: 10px;
  position: relative;
}
.bds067 .list-table input[type="text"] {
    width: 100px;
    margin-right: 28px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/TableModal.vue